var _style, _g, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgALogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1920 1080",
    style: {
      enableBackground: "new 0 0 1920 1080"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:url(#SVGID_1_);}\n\t.st1{fill:url(#SVGID_00000178906696449495764620000002846943634272578493_);}\n\t.st2{fill:url(#SVGID_00000132797106739873470020000013816747934257334422_);}\n\t.st3{fill:url(#SVGID_00000181089065433281970940000002671384073669476523_);}\n\t.st4{fill:url(#SVGID_00000058567103496059203920000002208620460763520642_);}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Camada_1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Camada_2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 1389.9855,
    y1: 863.2595,
    x2: 988.1772,
    y2: 615.6335
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#AB1917"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2319,
    style: {
      stopColor: "#C5634A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.462,
    style: {
      stopColor: "#DDA691"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6509,
    style: {
      stopColor: "#F0D6CB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7917,
    style: {
      stopColor: "#FBF4F1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8687,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1431.29,943.64c0,0-1.01,1.14-2.94,3.16c-78.84,82.43-190.64,63.83-257.57-28.52l-168.78-249.51 l115.51-160.1c0,0,28.56-29.59,67.08,34.62C1214.14,592.55,1431.29,943.64,1431.29,943.64z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000080910125006659347290000007900959540516788915_",
    gradientUnits: "userSpaceOnUse",
    x1: 599.6119,
    y1: 1066.1356,
    x2: 1038.7976,
    y2: 440.0624
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#AB1917"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2319,
    style: {
      stopColor: "#C5634A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.462,
    style: {
      stopColor: "#DDA691"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6509,
    style: {
      stopColor: "#F0D6CB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7917,
    style: {
      stopColor: "#FBF4F1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8687,
    style: {
      stopColor: "#FFFFFF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000080910125006659347290000007900959540516788915_)"
    },
    d: "M1001.99,668.77L849.01,894.75 c-47.27,69.82-126.1,111.65-210.42,111.65H533.22l45-67.45l361.39-541.69L1001.99,668.77z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000121961713434023633310000004779142409832775068_",
    gradientUnits: "userSpaceOnUse",
    x1: 533.3329,
    y1: 844.4026,
    x2: 888.4193,
    y2: 302.4287
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#AB1917"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2319,
    style: {
      stopColor: "#C5634A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.462,
    style: {
      stopColor: "#DDA691"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6509,
    style: {
      stopColor: "#F0D6CB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7917,
    style: {
      stopColor: "#FBF4F1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8687,
    style: {
      stopColor: "#FFFFFF"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000121961713434023633310000004779142409832775068_)"
    },
    points: "1027.67,268.83 877.24,162.43  429.6,826.69 310.36,1005.78 532.33,1006.48  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000000913726094042962680000017250372679890944389_",
    gradientUnits: "userSpaceOnUse",
    x1: 229.6528,
    y1: 494.0097,
    x2: 1345.014,
    y2: 476.9812,
    gradientTransform: "matrix(-1 0 0 1 1825.562 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#034E93"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0696,
    style: {
      stopColor: "#155196"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1719,
    style: {
      stopColor: "#2F5C9E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2943,
    style: {
      stopColor: "#516FAB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4324,
    style: {
      stopColor: "#7C8DBF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5835,
    style: {
      stopColor: "#B2B8D9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7433,
    style: {
      stopColor: "#EEEFF8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7851,
    style: {
      stopColor: "#FFFFFF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000000913726094042962680000017250372679890944389_)"
    },
    d: "M699.23,759.35L1180.86,36.9 l211.19,300.11c21.37,30.37,33.04,66.51,33.47,103.64l5.77,501.62c0,0-205.47-308.21-244-385.27 c-38.53-77.05-89.9-12.84-89.9-12.84L906.28,807.8c0,0-72.33,108.86-158.59,83.7C641.97,860.67,699.23,759.35,699.23,759.35z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000050650925294653766960000014700994108299529894_",
    gradientUnits: "userSpaceOnUse",
    x1: 1045.7435,
    y1: 44.7823,
    x2: 718.6904,
    y2: 628.8058
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#034E93"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0696,
    style: {
      stopColor: "#155196"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1719,
    style: {
      stopColor: "#2F5C9E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2943,
    style: {
      stopColor: "#516FAB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4324,
    style: {
      stopColor: "#7C8DBF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5835,
    style: {
      stopColor: "#B2B8D9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7433,
    style: {
      stopColor: "#EEEFF8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7851,
    style: {
      stopColor: "#FFFFFF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000050650925294653766960000014700994108299529894_)"
    },
    d: "M1180.26,36.92l-134.2,1.3 c-55.52,0.54-107.22,28.38-138.23,74.45L730.62,375.95c-56.81,85.98-0.55,198.38,122.79,149.92l17.62-22.03L1180.26,36.92z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgALogo);
export default __webpack_public_path__ + "static/media/a-logo.ced42074a0bdffb7cb1fb5aab77aa167.svg";
export { ForwardRef as ReactComponent };